import type { CompanySettings } from "@/types";

// EMPTY ON PURPOSE. This seeds the Settings form for the instant before the
// real values arrive from Odoo's company_settings.
//
// It used to carry a full fake identity ("Anixify Cabling Solutions Pvt.
// Ltd.", a GSTIN, an address), which meant a hardcoded company briefly
// rendered on screen and, worse, gave the impression the app had company
// data when nothing had been entered. There is now exactly ONE source of
// company identity -- what an Admin types into Settings -- and a blank form
// is the honest representation of "nothing entered yet".
//
// Do not put a company name back here. If you need a value, type it into
// Settings.
export const mockCompanySettings: CompanySettings = {
  companyName: "",
  gstin: "",
  registeredAddress: "",
  contactEmail: "",
  contactPhone: "",
  // warehouse-master: the stored default's id; "" = not set (the real value
  // is loaded from the server).
  defaultWarehouse: "",
  defaultQuoteValidityDays: 30,
};
